import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import Tab from "components/Tab";
import SnippetInstructions from "../../integrate/_snippets/install-js-snippet.mdx";
import SDKs from "../../integrate/_snippets/sdks.mdx";
import Frameworks from "../../integrate/_snippets/frameworks.mdx";
import API from "../../integrate/_snippets/api.mdx";
import Wizard from "./wizard.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {/* prettier-ignore */}
    <Tab.Group tabs={['wizard', 'snippet', 'sdks', 'guides', 'api']}>
    <Tab.List>  
        <Tab mdxType="Tab">AI wizard</Tab>
        <Tab mdxType="Tab">JS snippet</Tab>
        <Tab count="14" mdxType="Tab">Libraries</Tab>
        <Tab count="22" mdxType="Tab">Framework guides</Tab>
        <Tab mdxType="Tab">API</Tab>
    </Tab.List>
    <Tab.Panels>
        <Tab.Panel>
            <Wizard mdxType="Wizard" />
        </Tab.Panel>
        <Tab.Panel>
            <SnippetInstructions mdxType="SnippetInstructions" />
        </Tab.Panel>
        <Tab.Panel>
            <SDKs mdxType="SDKs" />
        </Tab.Panel>
        <Tab.Panel>
            <Frameworks mdxType="Frameworks" />
        </Tab.Panel>
        <Tab.Panel>
            <API mdxType="API" />
        </Tab.Panel>
    </Tab.Panels>
    </Tab.Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      